import { CUSTOMER_EXTERNAL_REFERENCE_KEY, getCustomerByExternalReference, } from "../../customer/index.js";
import { fetchSubscriptionVariantsBySku } from "../../subscription-product/queries/fetchSubscriptionVariants.pim.js";
import { getAllSubscriptionContracts } from "../queries/getAllSubscriptionContracts.subscriptions.js";
import { isAlreadySubscribed } from "../utils/isAlreadySubscribed.js";
export async function checkIfAlreadySubscribed({ phone, identifier }, subscriptionSku, { client }) {
    let customerIdentifier = identifier;
    if (phone) {
        const customer = await getCustomerByExternalReference({ value: phone, key: CUSTOMER_EXTERNAL_REFERENCE_KEY.PHONE }, { client });
        if (!customer?.identifier)
            return false;
        customerIdentifier = customer.identifier;
    }
    if (!customerIdentifier)
        return false;
    const existingContracts = await getAllSubscriptionContracts({ client }, customerIdentifier);
    if (!existingContracts?.length)
        return false;
    const subscriptionVariantsSkus = await fetchSubscriptionVariantsBySku({ sku: subscriptionSku }, { client });
    return isAlreadySubscribed(subscriptionVariantsSkus, existingContracts);
}
